<template>
  <f-dashboard-content-wrapper>
    <f-list
      :store="storeId"
      :query="query"
    >
      <template #list-header>
        <mandate-header></mandate-header>
      </template>

      <template #list-item="{ item }">
        <mandate-item
          :mandate="item"
          :selectable="false"
        ></mandate-item>
      </template>
    </f-list>
  </f-dashboard-content-wrapper>
</template>

<script>
  import { computed, ref } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'
  import useRoles from '@composables/use-roles'
  import MandateItem from './item/mandate-item'
  import MandateHeader from './header/mandate-header'
  
  export default {
    setup () {
      const userId = computed(() => router.currentRoute.value.params.id)
      const storeId = ref('@freebe/mandates')
      const query = { user_id: userId.value }
      const { checkPermissions } = useRoles()

      if (!checkPermissions('freebe/mandates:find')) {
        router.replace({ 
          name: 'user-profile',
          params: {
            id: userId.value
          } 
        })
      }

      return {
        storeId,
        query,
      }
    },

    components: {
      MandateItem,
      MandateHeader,
    },
  }
</script>